import React, { useRef, useState } from "react";
import styles from "./DropdownMenu.module.scss";
import useOnClickOutside from "utils/useOnClickOutside";
import { formatCurrentBrake } from "utils/formatCurrentBrake";
import classNames from "classnames";

const DropdownMenu = ({
  className,
  fieldName = "",
  labelText = "",
  data = [],
  setShowModal,
  setModalState,
  idRow = "",
  changeValueOfTime,
  timeValue = [],
  handleChange,
  setTime,
  schedulesData = [],
  currentScreen = "",
  editingId = "",
  selectedMinDuration = "",
  setSelectedMinDuration,
  selectedMaxDuration,
  setSelectedMaxDuration,
  setSelectedEndMax,
  setSelectedEndMin,
  setSelectedStartMax,
  setSelectedStartMin,
  selectedEndMax,
  selectedEndMin,
  selectedStartMax,
  selectedStartMin,
  setSelectedBreak,
  setSelectedTimezone,
  setSelectedForecasting,
  selectedBreak = "",
  selectedTimezone,
  selectedForecasting = "",
  formErrors,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const containerRef = useRef();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleItemClick = (item) => {
    switch (fieldName) {
      case "breaks":
        setSelectedBreak(`min ${item.min}, \nmax ${item.max}`);

        break;
      case "timezone":
        setSelectedTimezone(item);
        break;
      case "forecasting":
        setSelectedForecasting(
          `start: early ${item.start_early}, late ${item.start_late}, \nend: early ${item.end_early}, late ${item.end_late}`,
        );
        break;
      case "min":
        setSelectedMinDuration(`${item}`);
        break;
      case "max":
        setSelectedMaxDuration(`${item}`);
        break;
      case "startMin":
        setSelectedStartMin(`${item}`);
        break;
      case "startMax":
        setSelectedStartMax(`${item}`);
        break;
      case "endMin":
        setSelectedEndMin(`${item}`);
        break;
      case "endMax":
        setSelectedEndMax(`${item}`);
        break;
      case "start_hours":
        changeValueOfTime(item, fieldName, idRow, setTime);

        break;
      case "end_hours":
        changeValueOfTime(item, fieldName, idRow, setTime);

        break;
      case "start_minutes":
        changeValueOfTime(item, fieldName, idRow, setTime);

        break;
      case "end_minutes":
        changeValueOfTime(item, fieldName, idRow, setTime);

        break;
      default:
        return;
    }

    setIsOpen(false);
  };
  useOnClickOutside(containerRef, () => setIsOpen(false));

  const handleAddWorkTimeForecasting = (id) => {
    setShowModal(true);
    setModalState("addWorkTimeForecasting");
  };

  const handleAddBreake = (id) => {
    setShowModal(true);
    setModalState("addBrake");
  };

  return (
    <div className={className} ref={containerRef}>
      <label htmlFor={fieldName + [idRow]} className={styles.label}>
        {labelText}
      </label>
      <input
        id={fieldName + [idRow]}
        name={fieldName}
        type="text"
        required
        value={
          currentScreen === "edit" && fieldName === "breaks"
            ? selectedBreak ||
              formatCurrentBrake(schedulesData[editingId].breakDuration)
            : currentScreen === "edit" && fieldName === "forecasting"
            ? selectedForecasting ||
              schedulesData[editingId].work_time_forecasting
            : currentScreen === "edit" && fieldName === "timezone"
            ? selectedTimezone.title || "PST"
            : fieldName === "start_hours" ||
              fieldName === "end_hours" ||
              fieldName === "start_minutes" ||
              fieldName === "end_minutes"
            ? timeValue[fieldName] || ""
            : fieldName === "min"
            ? selectedMinDuration
            : fieldName === "max"
            ? selectedMaxDuration
            : fieldName === "startMin"
            ? selectedStartMin
            : fieldName === "startMax"
            ? selectedStartMax
            : fieldName === "endMin"
            ? selectedEndMin
            : fieldName === "endMax"
            ? selectedEndMax
            : fieldName === "breaks"
            ? selectedBreak
            : fieldName === "timezone"
            ? selectedTimezone.title || ""
            : fieldName === "forecasting"
            ? selectedForecasting
            : ""
        }
        onClick={toggleMenu}
        readOnly
        className={classNames(styles.input, formErrors && styles.inputError)}
      />
      {formErrors && (
        <p
          className={classNames(
            styles.error_message,
            formErrors.length !== 0 && styles.active,
          )}
        >
          {formErrors.breaks}
        </p>
      )}
      {isOpen && (
        <div className={styles.dropdownMenuWrapper}>
          <ul className={styles.dropdownMenu}>
            {data.map((item, index) => (
              <li
                key={index}
                onClick={() => handleItemClick(item)}
                className={styles.item}
              >
                {fieldName === "breaks" && (
                  <span className={styles.minMax}>
                    min <span className={styles.minColor}>{item.min}</span>, max{" "}
                    <span className={styles.maxColor}>{item.max}</span>
                  </span>
                )}
                {fieldName === "timezone" && item.title}
                {fieldName === "forecasting" && (
                  <>
                    <span className={styles.minMax}>
                      start: early{" "}
                      <span className={styles.minColor}>
                        {item.start_early},{" "}
                      </span>
                      late{" "}
                      <span className={styles.maxColor}>
                        {item.start_late},
                      </span>
                    </span>
                    <span className={styles.minMax}>
                      {" "}
                      {`\n`}end: early{" "}
                      <span className={styles.minColor}>
                        {item.end_early},{" "}
                      </span>
                      late{" "}
                      <span className={styles.maxColor}>{item.end_late}</span>
                    </span>
                  </>
                )}
                {fieldName === "min" && item}
                {fieldName === "max" && item}
                {fieldName === "start_hours" && item}
                {fieldName === "end_hours" && item}
                {fieldName === "start_minutes" && item}
                {fieldName === "end_minutes" && item}
                {fieldName === "startMin" && item}
                {fieldName === "startMax" && item}
                {fieldName === "endMin" && item}
                {fieldName === "endMax" && item}
              </li>
            ))}
            {fieldName === "breaks" && (
              <li onClick={() => setIsOpen(false)} className={styles.item}>
                <button
                  className={styles.addListButton}
                  onClick={() => handleAddBreake()}
                >
                  + Add Break
                </button>
              </li>
            )}

            {fieldName === "forecasting" && (
              <li onClick={() => setIsOpen(false)} className={styles.item}>
                <button
                  className={styles.addListButton}
                  onClick={() => handleAddWorkTimeForecasting()}
                >
                  + Add Work Time Forecasting
                </button>
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
